import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'GenerateButton',
  props: {
    buttonName: { default: i18n.global.t('pages.accounts.form.button.autoCreate') }
  },
  emits: ['generate'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props

function ckick() {
  emits("generate")
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    color: "primary",
    class: "white--text",
    onClick: ckick
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.buttonName), 1)
    ]),
    _: 1
  }))
}
}

})